var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "pt-1", attrs: { lg: "8", "offset-lg": "2" } },
                [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-tabs",
                        { attrs: { card: "" } },
                        [
                          _c(
                            "b-tab",
                            {
                              attrs: {
                                title: _vm.$t("tabs.automatic"),
                                active: ""
                              }
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "my-2" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "ml-3",
                                      attrs: { variant: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showAddReport()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("buttons.add")) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  items: _vm.automaticpaymentreports,
                                  fields: _vm.fields,
                                  small: "",
                                  responsive: "xl"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key:
                                      "head(HEAD_AutomaticPaymentReportTypeID)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("table.headers.type")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(Distributor)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "table.headers.distributor"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(System.SerialNumber)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("table.headers.serial")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(System.Actions)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("table.headers.actions")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(AutomaticPaymentReportTypeID)",
                                    fn: function(data) {
                                      return [
                                        data.item
                                          .AutomaticPaymentReportTypeID == 10
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("table.types.create")
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        data.item
                                          .AutomaticPaymentReportTypeID == 20
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("table.types.monthly")
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(Distributor)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              data.item.Distributor ||
                                                _vm.$t("table.all")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(System.SerialNumber)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              (data.item.System || {})
                                                .SerialNumber ||
                                                _vm.$t("table.all")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(Actions)",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showDeleteReport(
                                                  data
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("buttons.delete")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: _vm.$t("tabs.manual") } },
                            [
                              _c(
                                "b-form",
                                {
                                  attrs: {
                                    onsubmit: "return false",
                                    "data-vv-scope": "paymentreport"
                                  },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.validateBeforeSubmit(
                                        "paymentreport",
                                        _vm.submitNewPaymentReport
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        horizontal: "",
                                        "label-cols": 3,
                                        "label-size": "sm",
                                        label: _vm.$t("form.fields.distributor")
                                      }
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass: "mb-3",
                                        attrs: { options: _vm.distributors },
                                        model: {
                                          value: _vm.selected.distributor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selected,
                                              "distributor",
                                              $$v
                                            )
                                          },
                                          expression: "selected.distributor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        horizontal: "",
                                        "label-cols": 3,
                                        "label-size": "sm",
                                        label: _vm.$t(
                                          "form.fields.serialnumber"
                                        )
                                      }
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass: "mb-3",
                                        attrs: { options: _vm.systemSelection },
                                        model: {
                                          value: _vm.selected.system,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selected,
                                              "system",
                                              $$v
                                            )
                                          },
                                          expression: "selected.system"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        horizontal: "",
                                        "label-cols": 3,
                                        "label-size": "sm",
                                        label: _vm.$t("form.fields.from")
                                      }
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass: "form-control",
                                        attrs: {
                                          name: "from",
                                          config: _vm.dateSelectConfig
                                        },
                                        on: { "on-close": function($event) {} },
                                        model: {
                                          value: _vm.selected.from,
                                          callback: function($$v) {
                                            _vm.$set(_vm.selected, "from", $$v)
                                          },
                                          expression: "selected.from"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        horizontal: "",
                                        "label-cols": 3,
                                        "label-size": "sm",
                                        label: _vm.$t("form.fields.to")
                                      }
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass: "form-control",
                                        attrs: {
                                          name: "to",
                                          config: _vm.dateSelectConfig
                                        },
                                        on: { "on-close": function($event) {} },
                                        model: {
                                          value: _vm.selected.to,
                                          callback: function($$v) {
                                            _vm.$set(_vm.selected, "to", $$v)
                                          },
                                          expression: "selected.to"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        type: "submit",
                                        variant: "outline-success",
                                        block: ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("buttons.create")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteAutomaticPaymentReportConfirm",
          attrs: { "hide-footer": "", title: _vm.$t("form.title.delete") }
        },
        [
          _c("div", { staticClass: "d-block text-center" }, [
            _c("h6", [_vm._v(_vm._s(_vm.$t("form.texts.delete", "")))])
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-danger", block: "" },
              on: {
                click: function($event) {
                  return _vm.deleteAutomaticPaymentReport()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("buttons.delete")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addAutomaticPaymentReportConfirm",
          attrs: { "hide-footer": "", title: _vm.$t("form.title.add") }
        },
        [
          _c(
            "b-form",
            {
              attrs: {
                onsubmit: "return false",
                "data-vv-scope": "automaticpaymentreport"
              },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateBeforeSubmit(
                    "automaticpaymentreport",
                    _vm.submitNewAutomaticPaymentReport
                  )
                }
              }
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    horizontal: "",
                    "label-cols": 3,
                    "label-size": "sm",
                    label: _vm.$t("form.fields.type")
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true, is_not: null },
                          expression: "{ required: true, is_not: null }"
                        }
                      ],
                      staticClass: "mb-3",
                      attrs: { name: "type" },
                      model: {
                        value: _vm.selected.automaticpaymentreporttype,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.selected,
                            "automaticpaymentreporttype",
                            $$v
                          )
                        },
                        expression: "selected.automaticpaymentreporttype"
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { disabled: "" },
                          domProps: { value: undefined }
                        },
                        [_vm._v(_vm._s(_vm.$t("form.options.types.select")))]
                      ),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 10 } }, [
                        _vm._v(_vm._s(_vm.$t("form.options.types.oncreate")))
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 20 } }, [
                        _vm._v(_vm._s(_vm.$t("form.options.types.monthly")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("automaticpaymentreport.type"),
                          expression:
                            "errors.has('automaticpaymentreport.type')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.errors.first("automaticpaymentreport.type"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    horizontal: "",
                    "label-cols": 3,
                    "label-size": "sm",
                    label: _vm.$t("form.fields.distributor")
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: { options: _vm.distributors },
                    model: {
                      value: _vm.selected.distributor,
                      callback: function($$v) {
                        _vm.$set(_vm.selected, "distributor", $$v)
                      },
                      expression: "selected.distributor"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    horizontal: "",
                    "label-cols": 3,
                    "label-size": "sm",
                    label: _vm.$t("form.fields.serialnumber")
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: { options: _vm.systemSelection },
                    model: {
                      value: _vm.selected.system,
                      callback: function($$v) {
                        _vm.$set(_vm.selected, "system", $$v)
                      },
                      expression: "selected.system"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mt-3",
                  attrs: {
                    type: "submit",
                    variant: "outline-success",
                    block: ""
                  }
                },
                [_vm._v(_vm._s(_vm.$t("buttons.add")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "paymentReportRequested",
          attrs: {
            title: _vm.$t("confirm.title"),
            "cancel-disabled": "",
            "ok-only": ""
          }
        },
        [
          _c("p", { staticClass: "my-4" }, [
            _vm._v(_vm._s(_vm.$t("confirm.content", { email: _vm.userEmail })))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc2fb234", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc2fb234","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/TransactionReports.vue
// module id = 779
// module chunks = 0